<div class="d-flex flex-stack flex-wrap pt-10">
  <div class="d-flex align-items-center gap-6">
    <div class="flex align-items-center">
      <label for="pageSizeSelect" class="me-2 fs-6 fw-semibold text-gray-700">
        {{ "pageSize" | translate }}:
      </label>
      <select
        id="pageSizeSelect"
        (change)="changePageSize($event)"
        [(ngModel)]="pageSize"
        class="cursor-pointer outline-none"
      >
        <option *ngFor="let size of pageSizes" [value]="size">
          {{ size }}
        </option>
      </select>
    </div>
    <div class="fs-6 fw-semibold text-gray-700">
      {{ items.length }} / {{ totalItems }}
      <span class="text-lowercase">{{ "showingDatas" | translate }}</span>
    </div>
  </div>
  <ul class="pagination">
    <li
      class="page-item previous cursor-pointer"
      [class.disabled]="currentPage === 1"
    >
      <a class="page-link" (click)="changePage(currentPage - 1)">
        <i class="previous"></i>
      </a>
    </li>
    <li class="page-item cursor-pointer" [class.active]="currentPage === 1">
      <a class="page-link" (click)="changePage(1)">1</a>
    </li>

    <li *ngIf="currentPage > 3" class="page-item disabled">
      <span class="page-link">...</span>
    </li>

    <ng-container *ngFor="let page of getMiddlePages(); let i = index">
      <li
        class="page-item cursor-pointer"
        [class.active]="currentPage === page"
      >
        <a class="page-link" (click)="changePage(page)">{{ page }}</a>
      </li>
    </ng-container>

    <li *ngIf="currentPage < totalPage - 2" class="page-item disabled">
      <span class="page-link">...</span>
    </li>
    <li
      *ngIf="totalPage > 1"
      class="page-item cursor-pointer"
      [class.active]="currentPage === totalPage"
    >
      <a class="page-link" (click)="changePage(totalPage)">{{ totalPage }}</a>
    </li>
    <li
      class="page-item next cursor-pointer"
      [class.disabled]="currentPage === totalPage"
    >
      <a class="page-link" (click)="changePage(currentPage + 1)">
        <i class="next"></i>
      </a>
    </li>
  </ul>
</div>
